import { jsx as _jsx } from "react/jsx-runtime";
var Configure = function Configure(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.662 46A6.668 6.668 0 0 1 2 39.338c0-1.775.688-3.45 1.95-4.713L21.325 17.25c-.45-1.95-.425-3.887.075-5.787 1.413-5.438 6.263-9.338 11.788-9.475 1.825-.05 3.6.3 5.274 1.025l1.35.587-6.85 6.863a3.215 3.215 0 0 0-.95 2.287c0 .863.338 1.675.95 2.288a3.252 3.252 0 0 0 4.588 0l6.85-6.863.587 1.35a12.419 12.419 0 0 1 1.026 5.25c-.125 5.513-4.013 10.375-9.438 11.8-1.913.5-3.863.538-5.825.075L13.375 44.025A6.54 6.54 0 0 1 8.662 46ZM33.5 4h-.275c-4.638.113-8.713 3.4-9.913 7.975-.45 1.738-.425 3.525.063 5.325l.15.563L5.363 36.05A4.635 4.635 0 0 0 4 39.338 4.67 4.67 0 0 0 8.662 44c1.25 0 2.413-.487 3.288-1.362L30.138 24.45l.562.15c1.8.5 3.6.525 5.35.063 4.575-1.2 7.838-5.288 7.95-9.913.025-1.012-.1-2.012-.362-2.975l-4.688 4.688a5.247 5.247 0 0 1-7.413 0 5.252 5.252 0 0 1 0-7.425l4.688-4.688A11.004 11.004 0 0 0 33.5 4Z",
      fill: color
    })
  });
};
export default Configure;